import { render, staticRenderFns } from "./Tradeflows.vue?vue&type=template&id=0bb79d8a&scoped=true&"
import script from "./Tradeflows.vue?vue&type=script&lang=js&"
export * from "./Tradeflows.vue?vue&type=script&lang=js&"
import style0 from "./Tradeflows.vue?vue&type=style&index=0&id=0bb79d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb79d8a",
  null
  
)

export default component.exports